
import { Component, Mixins } from "vue-property-decorator";
import AuthenticateMixin from "./authenticate.mixin";
import BaseMixin from "@/views/base/base.mixin";
import { ErrorBag, Field } from "vee-validate";
import { LoginDto } from "./authenticate.types";
import { resetAllState } from "@/store/resetAllState";

@Component
export default class Login extends Mixins(AuthenticateMixin, BaseMixin) {
  loginDto: LoginDto = new LoginDto();
  passwordShow = false;
  loading = false;

  veeFields!: Field;
  veeErrors!: ErrorBag;

  mounted() {
    resetAllState(this.$store);
  }

  viewPassword() {
    this.passwordShow = !this.passwordShow;
  }

  validateState(ref: keyof Field) {
  if (
      this.veeFields[ref] &&
      (this.veeFields[ref].dirty || 
      this.veeFields[ref].validated)
  ) {
      return !this.veeErrors.has(ref);
  }
  return null;
  }

  authenticate() {
    this.$validator.validateAll().then(async (isValid: boolean) => {
      if (isValid) {
        this.loading = true;
        await this.$store.dispatch("Authenticate/login", this.loginDto);
        this.loading = false;
        if (this.user?.token) {
          const redirect = this.$route.query.redirect as string | undefined;
          const defaultPath = this.user.role === 'Research' ? "/research" : "/summary";
          this.$router.push(redirect || defaultPath);
        }
      }   
    });
  }
}
